import { createFeatureSelector } from '@ngrx/store';

import {
  BusesResultsModuleState, busesResultsFeatureName
} from '@buses/bus-results/store/state/bus-results-module.state';


export const busResultsRootSelector = createFeatureSelector<BusesResultsModuleState>(busesResultsFeatureName);
